<template>
    <div class="textUpload">
        <h2>{{ titleUpload }}</h2>
        <p>{{ subtitletUpload }}</p>
    </div>
</template>
<script>
    export default {
        props: {
            titleUpload: {
                type: String,
                required: true
            },
            subtitletUpload: {
                type: String,
                required: true
            }
        }
    }
</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .textUpload{
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-self: center;
        width: 90%;
        font-size: 16px;
        font-weight: 500;
        color: #435254;
    }
    .textUpload p{
        margin: 0;
    }
    .textUpload h2 {
        font-size: 18px;
        font-weight: 500;
        color: #22232C;
    }
    .textUpload p {
        font-size: 14px;
        font-weight: 400;
        color: #435254;
    }
</style>
